import { useEffect, useState } from 'react';

import { useMe } from '../auth/context';
import { Modal } from '../components/Modal';
import { useFieldOnly, useProject } from '../projects/context';
import { tourEvent, tourStorageKey, tourSteps } from './tourSteps';

const seen = (key: string) => {
  try {
    return !!localStorage.getItem(key);
  } catch {
    return true;
  }
};

// WelcomeTour: kurze Einführung beim ersten Login (je Browser) passend zur Rolle; erneut über die KI-Hilfe. Erscheint
// erst nach Passwortwechsel und Login-Hinweis. In Tests nur auf Anforderung (Ereignis), damit sie nichts überdeckt.
export function WelcomeTour() {
  const me = useMe();
  const { can } = useProject();
  const fieldOnly = useFieldOnly();
  const key = tourStorageKey(me.user.id);
  const [open, setOpen] = useState(() => import.meta.env.MODE !== 'test' && !seen(key));
  const [step, setStep] = useState(0);
  useEffect(() => {
    const show = () => {
      setStep(0);
      setOpen(true);
    };
    window.addEventListener(tourEvent, show);
    return () => window.removeEventListener(tourEvent, show);
  }, []);
  if (!open || me.must_change_password || me.pending_notice) return null;
  const steps = tourSteps({ can, fieldOnly });
  const current = steps[Math.min(step, steps.length - 1)]!;
  const last = step >= steps.length - 1;
  const close = () => {
    try {
      localStorage.setItem(key, new Date().toISOString());
    } catch {
      // ohne Speicher erscheint die Einführung beim nächsten Mal erneut
    }
    setOpen(false);
  };
  return (
    <Modal
      title={current.title}
      onClose={close}
      actions={
        <>
          <button type="button" className="btn btn-ghost" onClick={close}>
            {last ? 'Schließen' : 'Überspringen'}
          </button>
          {step > 0 && (
            <button type="button" className="btn" onClick={() => setStep(step - 1)}>
              Zurück
            </button>
          )}
          <button type="button" className="btn btn-primary" data-autofocus onClick={() => (last ? close() : setStep(step + 1))}>
            {last ? 'Los geht’s' : 'Weiter'}
          </button>
        </>
      }
    >
      <p className="tour-text">{current.text}</p>
      <p className="tour-progress muted" aria-live="polite">
        Schritt {step + 1} von {steps.length}
      </p>
      <div className="tour-dots" aria-hidden="true">
        {steps.map((s, i) => (
          <span key={s.title} className={i === step ? 'tour-dot active' : 'tour-dot'} />
        ))}
      </div>
    </Modal>
  );
}
